import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock, BlockType, SettingType, Setting, IOMode,
} from '@appblocks/codegeneration/types';
import IOTibbit from '@appblocks/codegeneration/Tibbits/_IOTibbit';

export default class Tibbit_58 extends IOTibbit {
    constructor() {
        super();
        this.id = 'tibbit_58';
        this.name = 'Tibbit 58';
        this.lines = 2;
        this.mode = IOMode.OUTPUT;
        this.initLines();
    }
}
